import React from "react";
import { Form } from "../../../../assets/icons";
import { ReactComponent as DeleteDanger } from "../../../../app/newLayout/assets/svgIcon/shipment/DeleteDanger.svg";
import { IconContainer, CircleWrapper } from "../index.styles";

export const HistoryIcon = ({ type }) => {
  return (
    <IconContainer>
      {type === "+" && (
        <CircleWrapper>
          <svg
            width="8"
            height="8"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6 1V11M1 6H11" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </CircleWrapper>
      )}
      {type === "~" && <Form />}
      {type === "-" && <DeleteDanger />}
      {!["+", "~", "-"].includes(type) && (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="2" />
        </svg>
      )}
    </IconContainer>
  );
};
